import { render, staticRenderFns } from "./Invitacion.vue?vue&type=template&id=58703bfa"
import script from "./Invitacion.vue?vue&type=script&lang=js"
export * from "./Invitacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports